/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import checkout from "./form";

const {
    formField: {email, mobile, recaptcha, mobile_otp, email_otp},
} = checkout;
const emailField = localStorage.getItem("email");
const mobileField = localStorage.getItem("mobile");
const initialValues = {
    [email.name]: emailField ? emailField : "",
    [mobile.name]: mobileField ? mobileField : "",
    [recaptcha.name]: "",
    [mobile_otp.name]: "",
    [email_otp.name]: "",
};
export default initialValues;
